export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: 'https://eurocross.fstr.io',
  appInsightsKey: '3e60536f-ef6c-49be-9111-cf01dda516a7',
  mluviiToken: '7f5554f1-e2bd-430e-98ec-4a6a13b2bda5',
};
